import React from 'react';
import { Typography } from '@mui/material';

export const EmptyRemoteAccessState: React.FC = () => (
  <div className="flex flex-col items-center justify-center py-8 text-center w-full border-2 border-gray-200 rounded-md p-4">
    <Typography color="text.secondary" sx={{ fontWeight: 500 }}>
      No valid remote access targets available.
    </Typography>
    <Typography color="text.secondary" sx={{ mt: 1 }}>
      Please contact your administrator to request remote access.
    </Typography>
  </div>
);
